export default __webpack_public_path__ + "static/mast-7f7c97c591ca751c4a13ec49ce418f4a.jpg";